<div class="modal">
  <span class="helper"></span>
  <div>
    <div class="modal-content">
      <div class="close" (click)="hideHistList()">X</div>
      <table>
        <tr>
          <th>Paketname</th>
          <th>Änderungsdatum</th>
          <th>Benutzerschlüssel</th>
          <th>Rolle</th>
          <th>Status</th>
          <th>Export</th>
        </tr>
        <tr *ngFor="let hist of histList">
          <td>{{hist.beschreibung}}</td>
          <td>{{hist.changed | date:"dd.MM.yyyy HH:mm:ss"}}</td>
          <td>{{hist.userid}}</td>
          <td>{{hist.rolle}}</td>
          <td>{{hist.status}}</td>
          <td>
            <button (click)="exportMaklerPaketHistory(hist.id, hist.beschreibung, hist.changed, FileExtension.CSV)">CSV</button>
            &nbsp;
            <button (click)="exportMaklerPaketHistory(hist.id, hist.beschreibung, hist.changed, FileExtension.TEXT)">TEXT</button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>

